
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTimerGoogle as ObiTimerGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-timer-google.js';
 
 
 

 
 export const ObiTimerGoogle = createComponent({
   react: React,
   tagName: 'obi-timer-google',
   elementClass: ObiTimerGoogleElement,
   events: {
     
   }
  });
 
 